export const revealTilesOnMobile = () => {
    const tiles = document.querySelectorAll('.tile');
    if (!tiles.length) return;

    // Media query definiujemy raz
    const mobileQuery = window.matchMedia('(max-width: 992px)');

    const updateActiveTile = () => {
        // Sprawdzamy stan przy każdym wywołaniu zdarzenia
        if (!mobileQuery.matches) {
            // Czyszczenie klas, gdy użytkownik rozciągnie okno na desktopie
            tiles.forEach(tile => tile.classList.remove('tile--active'));
            return;
        }

        const viewportCenter = window.innerHeight / 2;
        let closestTile = null;
        let minDistance = Infinity;

        tiles.forEach((tile) => {
            const rect = tile.getBoundingClientRect();
            
            if (rect.bottom > 0 && rect.top < window.innerHeight) {
                const tileCenter = rect.top + rect.height / 2;
                const distance = Math.abs(viewportCenter - tileCenter);

                if (distance < minDistance) {
                    minDistance = distance;
                    closestTile = tile;
                }
            }
        });

        tiles.forEach((tile) => {
            tile.classList.toggle('tile--active', tile === closestTile);
        });
    };

    let ticking = false;
    const onScroll = () => {
        if (!ticking) {
            window.requestAnimationFrame(() => {
                updateActiveTile();
                ticking = false;
            });
            ticking = true;
        }
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });

    // Uruchomienie początkowe
    updateActiveTile();
};